





















































































import { Component, Prop, Vue, Inject } from "vue-property-decorator";
import { IProductCard } from "@/@types/menu/menu/menu";
import { IHeightStyle } from "@/@types/styles/height";
import { preferred_language } from "@/config/languags.config.json";

@Component({})
export default class MenuDemo extends Vue {
  @Prop({ type: Object, default: null }) card!: IProductCard;
  @Prop({ type: String, default: "" }) activeBar!: string;
  @Prop({ type: String, default: preferred_language }) language!: string;
  @Prop({ type: Number, default: 0 }) currencyType!: number;
  @Inject({ from: "dishFolder", default: null }) readonly folder!: string;
  show = false;
  number = 0;

  mainHeight: IHeightStyle = {
    minHeight: "auto",
    maxHeight: "auto",
  };

  calculateHeight(): void {
    this.mainHeight.maxHeight = sessionStorage.getItem("demo-height") + "px";
    this.mainHeight.minHeight = sessionStorage.getItem("demo-height") + "px";
    this.show = true;
  }

  mounted(): void {
    this.calculateHeight();
  }
}
